"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var ECSLogger = /** @class */ (function () {
    function ECSLogger(logger) {
        this.baseFields = {};
        this.logger = logger;
    }
    ECSLogger.prototype.debug = function (message, ecsFields) {
        this.logger.debug(message, (0, lodash_merge_1.default)(this.baseFields, ecsFields));
    };
    ECSLogger.prototype.info = function (message, ecsFields) {
        this.logger.info(message, (0, lodash_merge_1.default)(this.baseFields, ecsFields));
    };
    ECSLogger.prototype.warn = function (message, ecsFields) {
        this.logger.warn(message, (0, lodash_merge_1.default)(this.baseFields, ecsFields));
    };
    ECSLogger.prototype.error = function (message, ecsFields) {
        this.logger.error(message, (0, lodash_merge_1.default)(this.baseFields, ecsFields));
    };
    ECSLogger.prototype.getBaseLogger = function () {
        return this.logger;
    };
    ECSLogger.prototype.setBaseFields = function (baseFields) {
        this.baseFields = baseFields;
    };
    return ECSLogger;
}());
exports.default = ECSLogger;
